import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { allowParamOmit } from "./allowParamOmit";
var defaultShouldRenderFn = function defaultShouldRenderFn(props) {
  return props.shouldRender;
};
export var withRenderFlag = allowParamOmit(function (params) {
  return function (component) {
    var _ref = params !== null && params !== void 0 ? params : {},
      _ref$shouldRenderFn = _ref.shouldRenderFn,
      shouldRenderFn = _ref$shouldRenderFn === void 0 ? defaultShouldRenderFn : _ref$shouldRenderFn,
      _ref$fallback = _ref.fallback,
      fallback = _ref$fallback === void 0 ? null : _ref$fallback;
    var Component = component;

    // FIXME: shouldRender не всегда будет props'ом результирующего компонента, все зависит от shouldRenderFn
    var ConditionalRenderer = /*#__PURE__*/forwardRef(function (props, ref) {
      return shouldRenderFn(props) ? /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        ref: ref,
        shouldRender: undefined
      })) : fallback;
    });

    /**
     * Override Connector's name to withRenderFlag(%Component%)
     */
    if (process.env.NODE_ENV !== 'production') {
      var ComponentName = Component.displayName || Component.name || 'Component';
      ConditionalRenderer.displayName = "withRenderFlag(".concat(ComponentName, ")");
    }
    return ConditionalRenderer;
  };
});